<template>
  <a :href="href" target="_blank">{{ title }}</a>
</template>

<script setup lang="ts">
  const props = defineProps({
    href: { type: String, required: true },
    title: { type: String, required: true },
    color: { type: String, required: false, default: 'dodgerblue' },
  });
  const color = ref(props.color);
</script>

<style scoped>
  a:hover {
    color: v-bind(color);
    text-decoration: underline;
  }

  a {
    color: v-bind(color);
    text-decoration: none;
  }
</style>
